'use client'
import React, {createContext, Dispatch, SetStateAction, useState} from "react";

interface Props {
    children?: React.ReactNode
}

export const ContentContext = createContext<{ filterContent: string, setContent: Dispatch<SetStateAction<string>> }>({
    filterContent: '',
    setContent: (value) => value,
});

export const ContentTypeContext = createContext<{ filterContentType: string, setContentType: Dispatch<SetStateAction<string>> }>({
    filterContentType: '',
    setContentType: (value) => value,
});

export const YearContext = createContext<{ filterYear: string, setYear: Dispatch<SetStateAction<string>> }>({
    filterYear: '',
    setYear: (value) => value,
});

export const CountryContext = createContext<{ filterCountry: string, setCountry: Dispatch<SetStateAction<string>> }>({
    filterCountry: '',
    setCountry: (value) => value,
});

export function NewsFilterProvider({ children }:Props) {
    const [filterContent, setContent] = useState('')
    const [filterContentType, setContentType] = useState('')
    const [filterCountry, setCountry] = useState('')
    const [filterYear, setYear] = useState('')

    return (
        <ContentContext.Provider value={{filterContent, setContent}}>
            <ContentTypeContext.Provider value={{filterContentType, setContentType}}>
                <CountryContext.Provider value={{filterCountry, setCountry}}>
                    <YearContext.Provider value={{filterYear, setYear}}>
                        {children}
                    </YearContext.Provider>
                </CountryContext.Provider>
            </ContentTypeContext.Provider>
        </ContentContext.Provider>
    );
}
